import React, { createContext, useContext } from 'react'
import { Diagnostics } from '../../../services/diagnostics'


const diagnostics = new Diagnostics()

export const DiagnosticsContextClass = createContext(null)

export function DiagnosticsContext({
  children,
}) {
  


  return (
    <DiagnosticsContextClass.Provider value={
      diagnostics
    }>
        {children}
    </DiagnosticsContextClass.Provider>
  )
}

export function useDiagnosticsContext() {
  return useContext(DiagnosticsContextClass)
}


